<template>
  <div>
    <b-nav pills vertical>
      <b-nav-item>
        <router-link to="/people/expert"
          ><span>&#187;</span>知名专家</router-link
        >
      </b-nav-item>
      <b-nav-item>
        <router-link to="/people/researcher"
          ><span>&#187;</span>研究人员</router-link
        >
      </b-nav-item>
      <b-nav-item>
        <router-link to="/people/administrator"
          ><span>&#187;</span>行政人员</router-link
        >
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
</style>
